import '../styles/base.scss';
import '../styles/loader.scss';
import '../styles/landing.scss';
import '../styles/links.scss';
import '../styles/skill.scss';
import '../styles/projects.scss';
import '../styles/faq.scss';
import '../styles/contact.scss';